// Function to remove the loader element
function removeLoader() {
  const loader = document.getElementById('loader');
  if (loader) {
      loader.remove();
  }
}
/* Add only one product into cart for gem page PDP/Landing page start */
  $('body').on('click','.product-form__cart-submit', function(e){
    $(this).attr("disabled", true);
    $(this).css('opacity','1');
    let selling_plan_id = $("#selling_plan_id").val();
    let variant_id = $("#variant_id").val();

    // Trigger the GTM add_to_cart event
    // const eventName = "add_to_cart";
    // triggerGTMEvent(eventName, globalData.shop.currency, globalData.products);

    clearCart(selling_plan_id, variant_id, addToCart);
  });

  // $('body').on('click','.prevent-default-cart',function(e){
  //   e.preventDefault();
  //   window.location.href = '/cart'; 
  // });

  function addToCart(selling_plan_id, variant_id,)
  {
    data = {
      id: variant_id,
      quantity: 1,
      selling_plan: selling_plan_id
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }
    });
  }

  function clearCart(selling_plan_id, variant_id, myCallback)
  {
    const theUrl = '/cart/clear.js';
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open( "GET", theUrl, false ); // false for synchronous request
    xmlHttp.send( null );
    myCallback(selling_plan_id, variant_id);
  }
/* Add only one product into cart for gem page PDP/Landing page end  */

$( document ).ready(function() {
    // Check if the required section is already loaded
    if ($(".recharge-navigation-overview").length > 0) {
      setTimeout(function() {
        // Remove loader
        removeLoader();
      }, 2000);
    }
  /* If item already in cart then prevent to add product  */
  /*$.getJSON('/cart.js', function(cart) {
    // now have access to Shopify cart object
    var arr = [];
    $.each(cart.items, function(key, data){
      arr.push(data.product_id);
    });

    var count = 0;
    $.each(cart.items, function(key, data){
      var pro_id = data.product_id;
      if (pro_id == arr[count])
      {
        // $('.dis-pro-'+ pro_id).attr("disabled", true);
        // $('.dis-pro-'+ pro_id).css("display", "block"); 
      }
      count++;
    });
  });*/
  /* END code If item already in cart then prevent to add product  */

  /* customer address section default select UK */
  // $("#AddressCountryNew").val("United Kingdom");


  /* Prevent characters and allow only integer in mobile field on account adrress area */
  jQuery.fn.ForceNumericOnly =
    function()
  {
    return this.each(function()
                     {
      $(this).keydown(function(e)
                      {
        var key = e.charCode || e.keyCode || 0;
        // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
        // home, end, period, and numpad decimal
        return (
          key == 8 || 
          key == 9 ||
          key == 13 ||
          key == 46 ||
          key == 110 ||
          key == 190 ||
          (key >= 35 && key <= 40) ||
          (key >= 48 && key <= 57) ||
          (key >= 96 && key <= 105));
      });
    });
  };
  $(".custom-phone").ForceNumericOnly();
  /* END code Prevent character and allow only integer  */
  
  /* Hide subsc monthly text which is comes from app */
  setTimeout(
  function() 
  {
    $(".rc-selling-plans__label").css("display", "none");
  }, 3000);
  /* END Hide subsc monthly text which is comes from app */
  
  /* subscription custom text added above the cancellation button.
  $("<div class='custom-cancel-text'><br/>If you cancel your subscription, you will lose access to Nature+ at the end of the current billing period.</div>").insertAfter(".rct_subscription__cards");
   END subscription custom text added above the cancellation button. */
  
  /* change text on subscription page and not clicakble content
  var adress_text = $('.rc-subheading').text();
  if(adress_text == 'Shipping & billing')
  {
  	 $('.rc-subheading').text("Billing");
  }
  $(".subscription-shipping-and-billing").css("pointer-events", "none");
  END code change text on subscription page  */
                                          
}); 

/*region selection dropdown start*/
$('.confirmation').on('click', function () {
      return confirm('Are you sure you want to change the region? If you change region, you will need to reselect your items and restart the checkout process');
});

/* PDP addtocart selling plan error fix code 
$(window).on("load", function() {
  let url_string = window.location.href;
  if(url_string.includes("products/plus") || url_string.includes("gempages")){
    setTimeout(function() {
      $.getJSON('/cart.js', function(cart){ 
    	  var result = cart.item_count;
          // if(result < 1){
            $('.product-form__submit').attr("disabled", false);
            $('.product-form__cart-submit').attr("disabled", false);
            $('.product-form__cart-submit').attr("disabled-area", false);
            $('.product-form__cart-submit').removeAttr("aria-disabled");
          // }
	  });
    }, 2000);
  }
});
 END PDP addtocart selling plan error fix code */


<!-- product subscription validation start in cart page -->
  
/* updated by sagarn  on 17-Mar-22
  * Purpose: Subscription product should not be added into cart
**/

$(window).bind("load", function() {
      if (sessionStorage.getItem("duplicate_item_alert") == "1"){
        $('#alert_warning').css('display','block');
      }
      /*$.getJSON('/cart.js', function(cart) {
        $.each(cart.items, function(key, data){
          let qty = data.quantity;
          let productTitle = data.product_title;
          if(productTitle == "Subscribe to Nature+" && qty > 1){
            let product_title = data.product_title;
            let selling_plan = data.selling_plan_allocation.selling_plan.id;
            let form_type = 'product';
            let id= data.id;
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {selling_plan:selling_plan,form_type:form_type,id:id,quantity:1},
                success: function(){
                    sessionStorage.setItem("duplicate_item_alert", "1");
                    location.href="/cart"; 
                }
            });
          } else {
            sessionStorage.setItem("duplicate_item_alert", "0");
          }
        });
      });*/
      /** EOC */

      /* recharge 'no subscription' page. !! Atul G : 21-11-2023 !! START*/
      $("#customer_tab_content a[href='/account/login']").attr('href', '/account');
      $("#customer_tab_content img[src^='https://static.rechargecdn.com/static/images/logos']").css('display', 'none');
      /* recharge 'no subscription' page. !! Atul G : 21-11-2023 !! END*/

      /* reject Shopify marketing & anlytics cookies. !! Atul G : 18-03-2024 !! START*/
      const consent = window.sncc.consent();
      window.Shopify.loadFeatures(
          [
            {
              name: 'consent-tracking-api',
              version: '0.1',
            },
          ],
          error => {
            if (error) {
              console.log("consent-tracking-api failed. " + error)
            }
            // If error is false, the API has loaded and ready to use!
            window.Shopify.customerPrivacy.setTrackingConsent(
              {
                "analytics":    consent.C02,
                "marketing":    consent.C03,
                "preferences":  true
              },
              () => console.log("Consent captured")
            );
          },
        );
        document.addEventListener('sncc:update', event => {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              "analytics":    event.detail.C02,
              "marketing":    event.detail.C03,
              "preferences":  true
            },
            () => {
              console.log("shopify consent updated")
              window.dataLayer.push({
                  event: 'shopify.sncc.update',
                  ...event.detail
              })
            }
          );
        })
      /* reject Shopify marketing & anlytics cookies. !! Atul G : 18-03-2024 !! END*/

      /* add cancel subscription buttong on the Recharge dashboard. !! Supriya S : 04-06-2024 !! START*/
      let windowRecharegeObject = window.ReCharge;
      //if(windowRecharegeObject && windowRecharegeObject.subscriptions && windowRecharegeObject.subscriptions.customer.number_active_subscriptions > 0){
      if(windowRecharegeObject && windowRecharegeObject.customer && windowRecharegeObject.customer.number_active_subscriptions > 0){
          $('<a href="/pages/cancel-subscription" class="cancel-subscription-button">Cancel subscription</a>').insertAfter(".recharge-navigation-subscriptions");
      }
      /* add cancel subscription buttong on the Recharge dashboard. !! Supriya S : 04-06-2024 !! END*/

      /* Recharge dashboard customisations */
      $('[aria-label="Manage addresses"]').closest('div').css("display", "none");
      $('.recharge-navigation-customer').delay(2000).click(function () {
        setTimeout(function () { 
          $('[aria-label="Manage addresses"]').closest('div').css("display", "none");
        }, 200);
      });
      /* EOC */
	});
<!-- updated by sagar on 30-Dec-22: Script to remove warning message -->
let close = document.getElementsByClassName("closebtn");
let i;
  for (i = 0; i < close.length; i++) {
    close[i].onclick = function(){
      let div = this.parentElement;
      div.style.opacity = "0";
      setTimeout(function(){ div.style.display = "none"; }, 600);
    }
  }
  <!-- EOC -->
/*window.onload = function() {  
  $.getJSON('/cart.js', function(cart) {
    $.each(cart.items, function(key, data){
      let qty = data.quantity;
      let productTitle = data.product_title;
      if(productTitle == "Subscribe to Nature+" && qty > 1){
        //setTimeout(function() {
          document.getElementById('checkout').setAttribute("disabled","disabled");
        //}, 1000);
       
      }  
    });
  });
};*/  
<!-- product subscription validation end -->

/* updated by Ajay D  on 3-May-23
  * Purpose: Customer Address buttons not Working
**/
  //Add Address
$('.addAddress').click(function(){
  $('#AddAddress').toggle();
});
 //Edit Address
$('.EditFormButton').click(function(){
  let addressId = $(this).attr('data-address-id');
  $('#EditAddress_'+addressId).toggle();
});
 //Delete Address
$('.DeleteFormButton').click(function(){
  if (confirm($(this).attr('data-confirm-message'))) {
    Shopify.postLink($(this).attr('data-target'), {
      parameters: { _method: 'delete' },
    });
  }
});
//Cancel New Address
$('.cancelNewButton').click(function(){
  $('#AddAddress').hide();
});
//Cancel Edit Address
$('.cancelButton').click(function(){
  let addressId = $(this).attr('data-id');
  $('#EditAddress_'+addressId).hide();
});
// Customer Address buttons not Working End


//Added by lgarg on 31-10-23 to add valdation for quantity (Global Function)
function validate(from,postData,privateAppURL = ''){
  $.ajax({
    method: "POST",
    url: privateAppURL+"/api/store_validate",
    crossOrigin: true,
    data:postData,
    success: function (res) {
      if(res.length > 0){
        res.forEach(errorData => {
          //Remove the checkout button element in case of invalid data
          if(typeof errorData.function_name != 'undefined' && errorData.function_name == ''){
            $("#cart-errors").css("color","red");
            $("#cart-errors").text(errorData.message);
            $(".cart__ctas").remove();
          }

          //Remove the checkout element in case of multiple quanties
          if(typeof errorData.function_name != 'undefined' && errorData.function_name === 'checkQuantity' && errorData.status === 0){
            $(".cart__ctas").remove();  
          } 

          let currentURL = window.location.href;
          //Remove the checkout button element in case of duplicate subscription
          if(typeof errorData.function_name != 'undefined' && errorData.function_name === 'checkDuplicateSubscription' && errorData.status === 0){
            if(from === 'checkout' && currentURL.indexOf("payment_methods") === -1){
              //rediret to the cart page
              window.location.href = ' /cart';
            }
            //show duplicate subscription error message
            $("#cart-errors").css("color","red");
            $("#cart-errors").text(errorData.message);
            //Remove the checkout element
            $(".cart__ctas").remove();  
          } else {
            $("#checkout").removeAttr('disabled');
          }
        })
      } else {
        $("#checkout").removeAttr('disabled');
      }
    }
  });
}
// Reduce cancellation journey flow logic edited by supriya S
$(document).ready(function() {
  var customerId = '';
  if(document.getElementById('customer-data')) {
    customerId = document.getElementById('customer-data').dataset.customerId;
  }
  var rechargeId= '';
  if(document.getElementById('customer-data-recharge')) {
    rechargeId = document.getElementById('customer-data-recharge').dataset.customerRechargeId;
    if(rechargeId) {
      $.ajax({
        url: privateAppURL+"/api/getActiveSubscriptions?rechargeCustomerId="+rechargeId,
        crossOrigin: true,
        type: 'GET',
        success: function(response) {
          console.log(response);
          if(response.status == 200) {
            $('.show-form').removeClass('show-form-hide');
          } else {
            $('.show-alert').removeClass('show-alert-hide');
          }
        },
        error: function(xhr, status, error) {
          console.log(status);
          console.log(error);
          $('.show-alert').removeClass('show-alert-hide');
        }
    });
    } else {
      console.log(1);
      $('.show-alert').removeClass('show-alert-hide');
    }
  }
  $('#confirm-btn').prop('disabled', true);
  $('input[type="radio"][name="reason"]').click(function(){
    $('#confirm-btn').prop('disabled', false);
    if($(this).val() === "others") {
        $('#otherReason').show();
    } else {
        $('#otherReason').hide();
        $('#otherReason').val('');
    }
  });

  $('#cancelBtn').click(function () {
    // Route the user to the previous screen
    window.location.href = '/tools/recurring/login';
  });
  $('#confirm-btn').click(function () {
    if ($('input[name=reason]:checked').length > 0) {
      var result = confirm('Are you sure you want to cancel subscription?');
      if (result) {
        //var selectedReason = $('input[name="reason"]:checked').val(); 
        var reason;
        if ($('input[type="radio"][name="reason"]:checked').val() === "others") {
          reason = $('#otherReason').val();
        } else {
          reason = $('input[type="radio"][name="reason"]:checked').val();
        }

        $.ajax({
          url: privateAppURL + "/api/cancelSubscriptionApi",
          crossOrigin: true,
          type: 'POST',
          data: { reason: reason, customerId: customerId },
          success: function (response) {
            $('.alert-message .submitted-message p').html('You have cancelled your Nature+ subscription.');
            $('.alert-message').removeClass('cancel-form-submit-error').removeClass('cancel-form-error-true');
            $('.alert-message').addClass('cancel-form-submit-success').addClass('cancel-form-submit-true');
            $('.cancel-form-wrapper').hide();
            setTimeout(function () {
              location.href = "/tools/recurring/login";
            }, 5000);
          },
          error: function (xhr, status, error) {
            // This function is executed if the request fails
            console.error('Error:', status, error);
            // You can handle the error here
            $('.alert-message .submitted-message p').html('Something went wrong. Please try after Sometime.');
            $('.alert-message').removeClass('cancel-form-submit-success').removeClass('cancel-form-submit-true');
            $('.alert-message').addClass('cancel-form-submit-error').addClass('cancel-form-error-true');
          }
        });
      } else {
        // User clicked "No" or closed the dialog Do nothing
      }
    } else {
      // No radio button is selected, show an alert
      alert('Please select a reason to cancel');
    }
  });
});

$(document).ready(function () {
    /** Added by lgarg on 6-dec-24 to send the contact us data in GA  */
    $('[data-contact-us]').on('click', function (event) {
        // Prevent immediate navigation
        event.preventDefault();
        //subscribe the GA event
        Shopify.analytics.publish("contact_us", { count: 1});
        
        // Get the URL from the href attribute
        const url = $(this).attr('href');
        setTimeout(function () {
            // Redirect to the URL
            window.location.href = url;
        }, 500); // Delay of 500ms
    });
    /** Added by lgarg on 10-dec-24 to send the login event data in GA  */
    $('[data-login-link]').on('click', function (event) {
        // Prevent immediate navigation
        event.preventDefault();
        //subscribe the GA event
        Shopify.analytics.publish("login", { count: 1});
        
        // Get the URL from the href attribute
        const url = $(this).attr('href');
        setTimeout(function () {
            // Redirect to the URL
            window.location.href = url;
        }, 500); // Delay of 500ms
    });
    $('[data-login-button]').on('click', function (event) {
        Shopify.analytics.publish("login", { count: 1 });
    });
});
/** EOC */